/*!

=========================================================
* BLK Design System React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

export default function Footer() {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col md="3">
            <h1 className="title modernista">BFPortal.Pro</h1>
          </Col>
          <Col md="3">
            <Nav>
              <NavItem>
                <NavLink to="/" tag={Link}>
                  Home
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/add-game" tag={Link}>
                  Add Portal Game
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
          <Col md="3">

          </Col>
          <Col md="3">
            <h3 className="title">Follow us:</h3>
            <div className="btn-wrapper profile">
              <Button
                className="btn-icon btn-neutral btn-round btn-simple"
                color="default"
                href="https://twitter.com/bfportalpro"
                id="tooltiptwitter"
                target="_blank"
              >
                <i className="fab fa-twitter" />
              </Button>
              <UncontrolledTooltip delay={0} target="tooltiptwitter">
                Follow us
              </UncontrolledTooltip>
              <Button
                className="btn-icon btn-neutral btn-round btn-simple"
                color="default"
                href="https://www.twitch.tv/bfportalpro"
                id="tooltiptwitch"
                target="_blank"
              >
                <i className="fab fa-twitch" />
              </Button>
              <UncontrolledTooltip delay={0} target="tooltiptwitch">
                Watch us
              </UncontrolledTooltip>
              <Button
                className="btn-icon btn-neutral btn-round btn-simple"
                color="default"
                href="https://www.youtube.com/channel/UC7YDgGfBOAnhvxcM7nWVjvw"
                id="tooltipyoutube"
                target="_blank"
              >
                <i className="fab fa-youtube" />
              </Button>
              <UncontrolledTooltip delay={0} target="tooltipyoutube">
                Follow us
              </UncontrolledTooltip>
              <Button
                className="btn-icon btn-neutral btn-round btn-simple"
                color="default"
                href="https://discord.gg/gqRhNZZXm4"
                id="tooltipdiscord"
                target="_blank"
              >
                <i className="fab fa-discord" />
              </Button>
              <UncontrolledTooltip delay={0} target="tooltipdiscord">
                Join our Discord!
              </UncontrolledTooltip>

            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
